export const COMPANY_NAME_MAX_LENGTH = 256;

export function validateCompanyName(value: string): string {
    // Cannot be empty
    if (value.length === 0) {
        return 'shared.fields.company_name.error_required';
    }

    // Cannot be greater than 256 characters
    if (value.length > COMPANY_NAME_MAX_LENGTH) {
        return 'shared.fields.company_name.error_too_long';
    }

    return '';
}
